export const WIZARD_STEP = {
  SEARCH: 'search',
  ACCOUNT_QUESTION: 'account-question',
  ACCOUNT_YES: 'account-yes',
  ACCOUNT_NO: 'account-no',
  CONNECTING: 'connecting',
  SUCCESS: 'success',
}

export const CONNECTING_ANIMATION_MS = 4000

export const WIZARD_STEP_TITLE = {
  [WIZARD_STEP.SEARCH]: 'Find on OMS',
  [WIZARD_STEP.ACCOUNT_QUESTION]: 'Add supplier',
  [WIZARD_STEP.ACCOUNT_YES]: 'Add supplier',
  [WIZARD_STEP.ACCOUNT_NO]: 'No account number',
  [WIZARD_STEP.CONNECTING]: 'Adding supplier...',
  [WIZARD_STEP.SUCCESS]: 'Supplier added!',
}

export const WIZARD_PROGRESS_INDEX = {
  [WIZARD_STEP.SEARCH]: 0,
  [WIZARD_STEP.ACCOUNT_QUESTION]: 1,
  [WIZARD_STEP.ACCOUNT_YES]: 1,
  [WIZARD_STEP.ACCOUNT_NO]: 1,
  [WIZARD_STEP.CONNECTING]: 2,
  [WIZARD_STEP.SUCCESS]: 3,
}
